import React from 'react';
import OrgMembers from './OrgMembers';
import { FaUsers } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const TeamSidebar = () => {
    const { t } = useTranslation();

    return (
        <div
            style={{
                width: '275px',
                backgroundColor: '#e6fff2',
                display: 'flex',
                flexDirection: 'column',
                borderRight: '1px solid #c3e6cb',
                height: '100%',          // ← this is the only new line
                overflow: 'hidden',
            }}
        >
            {/* Sidebar title */}
            <div
                style={{
                    padding: '20px 15px 15px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    color: '#2e7d32',
                    fontWeight: 600,
                    fontSize: '16px',
                    borderBottom: '1px solid #b8e6c3',
                }}
            >
                <FaUsers />
                {t('manage_team')}
            </div>

            {/* Scrollable member list */}
            <div style={{ flex: 1, overflowY: 'auto', padding: '15px' }}>
                <OrgMembers />
            </div>
        </div>
    );
};

export default TeamSidebar;